import UserList from '@containers/setting/UserList';
import { useEffect } from 'react';

const UserListPage = () => {
  useEffect(() => {}, []);

  return <UserList />;
};

export default UserListPage;
